import type * as React from "react";

/** A large figure + label for KPIs and graph stats. */
export interface StatProps {
  value: React.ReactNode;
  label: React.ReactNode;
  /** Color of the figure. @default "neutral" */
  tone?: "person" | "company" | "event" | "opportunity" | "brand" | "neutral";
  /** @default "left" */
  align?: "left" | "center";
  style?: React.CSSProperties;
}

const TONES: Record<NonNullable<StatProps["tone"]>, string> = {
  person: "var(--entity-person)",
  company: "var(--entity-company)",
  event: "var(--entity-event)",
  opportunity: "var(--entity-opportunity)",
  brand: "var(--accent)",
  neutral: "var(--text-strong)",
};

export function Stat({ value, label, tone = "neutral", align = "left", style }: StatProps) {
  const color = TONES[tone];
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "2px", textAlign: align, ...style }}>
      <span
        style={
          {
            fontFamily: "var(--font-display)",
            fontSize: "var(--text-display-md)",
            fontWeight: "var(--fw-bold)",
            lineHeight: 1,
            color,
            letterSpacing: "var(--tracking-tight)",
            fontVariantNumeric: "tabular-nums",
          } as React.CSSProperties
        }
      >
        {value}
      </span>
      <span
        style={
          {
            fontFamily: "var(--font-sans)",
            fontSize: "var(--text-label)",
            fontWeight: "var(--fw-semibold)",
            color: "var(--text-muted)",
            letterSpacing: "0.02em",
          } as React.CSSProperties
        }
      >
        {label}
      </span>
    </div>
  );
}
